const terminalSessionStatuses = new Set([
  "invalid_site_session",
  "expired_site_session",
  "site_user_not_found",
]);

export function isTerminalSessionStatus(status) {
  return typeof status === "string" && terminalSessionStatuses.has(status);
}
